import React, { PropTypes } from "react";
import AmazonLink from "./AmazonLink";
import Description from "./Descriptions/Description";

const CarSeat = ({ brand, size }) => {
  return (
    <div className="col-sm-6 col-xs-12">
      <div className="panel panel-default car-seat-detail">
        <div className="panel-heading">
          <div className="row">
            <div className="col-xs-8">
              <h4>{size.size}</h4>
              <h5>{size.type}</h5>
            </div>
            <div className="col-xs-4">
              <AmazonLink brand={brand}
                size={size}
                linkText="Find it on Amazon"/>
            </div>
          </div>
        </div>
        <div className="row image-and-description">
          <img className="brand-size-label col-xs-2" src={process.env.PUBLIC_URL + "/img/" + size.image} alt={size.size} />
          <div className="col-xs-7 description-container">
            <Description size={size} />
          </div>
        </div>
      </div>
    </div>
  );
};

CarSeat.propTypes = {
  brand: PropTypes.object.isRequired,
  size: PropTypes.object.isRequired,
};

export default CarSeat;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/CarSeat.js
 **/